import React from 'react';

const WHATSAPP_COMMUNITY_LINK = 'https://chat.whatsapp.com/DZakClwkCzF4iqvfBYf7g5';

const WhatsAppFloatingButton: React.FC = () => (
  <a
    href={WHATSAPP_COMMUNITY_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Join our WhatsApp community"
    className="fixed bottom-5 right-5 z-[9999] flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110 active:scale-95 sm:bottom-6 sm:right-6"
    style={{ background: '#25D366' }}
  >
    <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden>
      <path d="M16.004 2.002c-7.732 0-14.002 6.27-14.002 14.002 0 2.468.654 4.876 1.896 6.99L2 30l7.186-1.884A13.94 13.94 0 0 0 16.004 30c7.732 0 14.002-6.27 14.002-14.002S23.736 2.002 16.004 2.002Zm0 25.604a11.56 11.56 0 0 1-5.9-1.614l-.424-.252-4.384 1.15 1.17-4.272-.276-.44a11.54 11.54 0 0 1-1.77-6.176c0-6.396 5.206-11.602 11.604-11.602 6.396 0 11.602 5.206 11.602 11.602 0 6.398-5.206 11.604-11.602 11.604h-.02Zm6.362-8.69c-.35-.174-2.066-1.02-2.386-1.136-.32-.116-.554-.174-.786.176-.232.35-.904 1.136-1.108 1.37-.204.232-.408.262-.758.088-.35-.176-1.476-.544-2.812-1.734-1.04-.926-1.742-2.07-1.946-2.42-.204-.35-.022-.538.154-.712.158-.156.35-.408.524-.612.176-.204.234-.35.352-.582.116-.232.058-.436-.03-.612-.088-.174-.786-1.896-1.078-2.596-.284-.682-.572-.59-.786-.6l-.67-.012c-.232 0-.612.088-.932.436-.32.35-1.224 1.196-1.224 2.916s1.254 3.382 1.428 3.614c.176.232 2.468 3.77 5.98 5.286.836.36 1.488.576 1.996.738.838.266 1.602.228 2.206.138.672-.1 2.066-.844 2.358-1.66.29-.816.29-1.516.204-1.66-.088-.146-.32-.232-.67-.408Z" />
    </svg>
    <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white shadow">
      +
    </span>
  </a>
);

export default React.memo(WhatsAppFloatingButton);
